/*
endpoint.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/*
 * @author andrade@ge.com @description Enables remote endpoint configuration fetch, and provide getters to use them
 *
 * Priority for overriding: 1. localStorage._endpoints 2. remote env variables (X-Endpoints)
 *
 */
define('modules/shell/services/endpoint.service',['angular'], function (ng) {
    'use strict';

    var module = ng.module('endpoint', []);

    module.provider('$Endpoint', function () {

        var $http;
        var $q;
        var initPromise = null;
        var endpointService = this;
        var remoteEndpoints = null;

        /**
         * Fetch environment configuration
         */
        this.init = function () {
            remoteEndpoints = sessionStorage.getItem('X-Endpoints');

            if (remoteEndpoints) {
                remoteEndpoints = JSON.parse(remoteEndpoints);
                return $q.when(remoteEndpoints);
            }

            var deferred = $q.defer();
            initPromise = deferred.promise;

            $http.get('appConfig.json').then(function (response) {
                var jsonEndpoints = response.endpoints;

                if (jsonEndpoints) {
                    remoteEndpoints = jsonEndpoints;
                } else {
                    console.error('Unable to set remote endpoints.');
                    remoteEndpoints = {};
                }

                deferred.resolve(remoteEndpoints);
                initPromise = null;

                return remoteEndpoints;
            },function (status) {
                console.error('Error loading endpoints from appConfig.json.');
                remoteEndpoints = {};
                deferred.reject(status);
            });

            return initPromise;

        };

        this.getEndpoints = function () {
            return remoteEndpoints;
        };

        this.getEndpoint = function (key) {
            var ep = this.getEndpoints();
            if (!ep || !ep[key]) {
                console.error('getEndpoint() - there is no key named ' + key);
                return '';
            } else {
                return ep[key];
            }
        };

        this.getEndpointAsync = function (key) {
            var ep = this.getEndpoints();
            if (!ep && initPromise) {
                console.warn('getEndpointAsync: ' + key + ' will require async resolution.');

                return initPromise.then(function () {
                    return endpointService.getEndpoint(key);
                });
            } else {
                return $q.when(this.getEndpoint(key));
            }
        };

        this.$get = ['$http', '$q', function (http, q) {
            $http = http;
            $q = q;
            return endpointService;
        }];
    });
});

